import { User, UserFilter } from '../react-app-env'

export const fetchPlans = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/subscription/plans`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })

    if (!res.ok) throw new Error('Failed to fetch plans')

    const data = await res.json()
    return data
  } catch (error) {
    console.error('Error fetching plans:', error)
  }
}

export const fetchUser = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/user/get`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })

    if (!res.ok) throw new Error('Failed to fetch plans')

    const data = await res.json()
    return data.user
  } catch (error) {
    console.error('Error fetching user:', error)
  }
}

export const fetchUsers = async (filter: UserFilter) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/user-admin/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(filter),
    })

    if (!res.ok) throw new Error('Failed to fetch users')

    const data = await res.json()
    return data
  } catch (error) {
    console.error('Error fetching users:', error)
    return { users: [] }
  }
}

export const deleteUserById = async (userId: string) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/user-admin/user/${userId}/delete`, {
      method: 'DELETE',
    })

    const data = await res.json()
    return data
  } catch (error) {
    console.error('Error deleting user:', error)
    return { ok: false }
  }
}

export const resendUserConfirmation = async (userId: string) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/company/user/confirm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId }),
    })

    const data = await res.json()
    return data
  } catch (error) {
    console.error('Error resending confirmation:', error)
    return { ok: false }
  }
}

export const changeClientView = async (view: 'card' | 'table') => {
  try {
    await fetch(`${process.env.REACT_APP_API_URL}/user/view`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientView: view }),
    })
  } catch (error) {
    console.error('Error user update:', error)
    return { ok: false }
  }
}

export const isDsSignAvailable = async (): Promise<{ signTeam: boolean }> => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/sign/team/exists`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    const data = await res.json()

    return data
  } catch (error) {
    console.error('Is sign team available: ', error)
    return { signTeam: false }
  }
}

export const fetchTeamOwner = async (): Promise<{ owner: User } | null> => {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/user-admin/team-owner`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    const data = await res.json()
    return { owner: data.users[0] || { firstName: '', lastName: '' } }
  } catch (error) {
    return null
  }
}
